import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { updatePayrollPartnerRoute } from '../api/constants';
import { onboardPackagesList } from '../constants';

type useUpdateCompanyPayrollProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useUpdateCompanyPayroll = ({
    setErrorText,
}: useUpdateCompanyPayrollProps) => {
    const client = useQueryClient();
    const { mutate: addUpdatePayrollPartners, isLoading: isUpdatingPayrollPartner } =
        useMutation({
            mutationFn: (variables: {
                email?: string;
                name?: string;
                company_name?: string;
                company_id: number
            }) =>
                axiosInstance
                    .post(updatePayrollPartnerRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries(onboardPackagesList);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        addUpdatePayrollPartners,
        isUpdatingPayrollPartner,
    };
};
